import Vue from 'vue'
import TableInput from './TableInput'
import TableSelect from './TableSelect'

Vue.component('table-input', TableInput)
Vue.component('table-select', TableSelect)
